import React, { Component, lazy, Suspense } from "react";
import "materialize-css/dist/css/materialize.min.css";
import "./App.css";
import { Modal, FloatingActionButton } from "materialize-css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import firebase from "firebase/app";
import "firebase/analytics";
import { getCookie, setCookie } from "./components/utils/cookies";

const Navbar = lazy(() => import("./components/layout/navigation/Navbar"));
const Footer = lazy(() => import("./components/layout/navigation/Footer"));
const Startsite = lazy(() => import("./components/layout/pages/Startsite"));
const Contact = lazy(() => import("./components/layout/pages/Contact"));
const Schooling = lazy(() => import("./components/layout/pages/Schooling"));
const Insights = lazy(() => import("./components/layout/pages/Insights"));
const Products = lazy(() => import("./components/layout/pages/Products"));
const Blog = lazy(() => import("./components/layout/pages/Blog"));
const BlogItem = lazy(() => import("./components/layout/pages/BlogItem"));
const ProductItem = lazy(() => import("./components/layout/pages/ProductItem"));
const Overview = lazy(() => import("./components/layout/pages/Overview"));
const Websites = lazy(() => import("./components/layout/pages/Websites"));
const Azure = lazy(() => import("./components/layout/pages/Azure"));
const Teams = lazy(() => import("./components/layout/pages/Teams"));
const SoftwareDevelopment = lazy(
  () => import("./components/layout/pages/SoftwareDevelopment")
);
const PowerPlatform = lazy(
  () => import("./components/layout/pages/PowerPlatform")
);
const Consultation = lazy(
  () => import("./components/layout/pages/Consultation")
);
const SharePoint = lazy(() => import("./components/layout/pages/SharePoint"));
const Impressum = lazy(() => import("./components/layout/pages/Impressum"));
const DataPrivacy = lazy(() => import("./components/layout/pages/DataPrivacy"));
const _404 = lazy(() => import("./components/layout/pages/_404"));

const renderLoader = () => <div />;

export class JetMinds extends Component {
  constructor(props) {
    super(props);
    this.mainAppRef = React.createRef();
    this.modalElem = React.createRef();
    this.fixedAchtionBtn = React.createRef();
    this.state = {
      scrollY: 0,
      analyticsReady: false,
    };
    this.agreeModalInstance = null;

    this.updateWindowScrolls = this.updateWindowScrolls.bind(this);
    this.enableAnalyticsAfterConsent = this.enableAnalyticsAfterConsent.bind(this);
    this.acceptCookies = this.acceptCookies.bind(this);
    this._scrollTop = this._scrollTop.bind(this);
  }

  componentDidMount() {
    var firebaseConfig = {
      apiKey: "AIzaSyDxpyMFgJxppSlpqwoobl7JNnW1257XW14",
      databaseURL: "https://jetmindsde.firebaseio.com",
      projectId: "jetmindsde",
      appId: "1:49529288234:web:54a78acb10501eae0eb553",
      measurementId: "G-NPKEWMT7EQ",
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    this.agreeModalInstance = Modal.init(this.modalElem.current, {
      preventScrolling: false,
      dismissible: false,
      inDuration: 100,
      outDuration: 800,
    });

    FloatingActionButton.init(this.fixedAchtionBtn.current, {
      hoverEnabled: false,
    });

    var agreedToCookies = getCookie("agreedToCookies");
    if (
      !agreedToCookies &&
      window.location.pathname.indexOf("datenschutzerklaerung") === -1
    ) {
      this.agreeModalInstance.open();
    } else if (agreedToCookies && !this.state.analyticsReady) {
      this.enableAnalyticsAfterConsent();
    }

    this.updateWindowScrolls();
    window.addEventListener("scroll", this.updateWindowScrolls, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateWindowScrolls);
    if (this.agreeModalInstance && typeof this.agreeModalInstance.destroy === "function") {
      try {
        this.agreeModalInstance.destroy();
      } catch (e) {}
    }
  }

  componentDidUpdate(prevProps, prevState) {
    var scrollY = this.state.scrollY;
    if (this.fixedAchtionBtn && this.fixedAchtionBtn.current) {
      var lis = this.fixedAchtionBtn.current.getElementsByTagName("li");
      if (lis && lis.length >= 3) {
        var show = scrollY > 400;
        lis[2].hidden = !show;
      }
    }
  }

  updateWindowScrolls() {
    var currentY = window.scrollY || document.documentElement.scrollTop || 0;
    if (currentY !== this.state.scrollY) {
      this.setState({ scrollY: currentY });
    }
  }

  enableAnalyticsAfterConsent() {
    try {
      if (typeof firebase.analytics === "function") {
        firebase.analytics();
      }
      this.setState({ analyticsReady: true });
    } catch (e) {
      console.warn("Analytics konnte nicht initialisiert werden:", e);
    }
  }

  acceptCookies(e) {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    setCookie("agreedToCookies", "true", {
      days: 180,
      path: "/",
      sameSite: "Lax",
      secure: window.location.protocol === "https:",
    });

    this.enableAnalyticsAfterConsent();

    if (this.agreeModalInstance && typeof this.agreeModalInstance.close === "function") {
      try {
        this.agreeModalInstance.close();
      } catch (e2) {}
    }
  }

  _scrollTop() {
    var animate = () => {
      var a = window.scrollY || document.documentElement.scrollTop || 0;
      if (a > 0) {
        requestAnimationFrame(animate);
        window.scrollTo(0, Math.trunc(a - a / 8));
      }
    };
    animate();
  }

  render() {
    return (
      <Suspense fallback={renderLoader()}>
        <div className="App" ref={this.mainAppRef}>
          <div className="fixed-action-btn" ref={this.fixedAchtionBtn}>
            <a role="button" className="btn-floating btn-large orange darken-4">
              <i className="large material-icons">menu</i>
            </a>
            <ul>
              <li>
                <a className="btn-floating orange" href="/kontakt">
                  <i className="material-icons">message</i>
                </a>
              </li>
              <li>
                <a className="btn-floating blue" href="tel:+49 15754945259">
                  <i className="material-icons">call</i>
                </a>
              </li>
              <li hidden>
                <a className="btn-floating teal lighten-2" href="mailto:info@jetminds.de">
                  <i className="material-icons">mail</i>
                </a>
              </li>
              <li>
                <a className="btn-floating grey darken-3" onClick={this._scrollTop}>
                  <i className="material-icons">keyboard_arrow_up</i>
                </a>
              </li>
            </ul>
          </div>

          <div id="modal1" className="modal privacy" ref={this.modalElem}>
            <div style={{ marginBottom: "30px" }} className="modal-content">
              <p>
                Um die Webseite optimal zu gestalten und fortlaufend zu
                verbessern, verwenden wir Cookies (u.&nbsp;a. für Google
                Analytics). Durch die weitere Nutzung der Webseite stimmen Sie
                der Verwendung zu. Weitere Informationen hierzu, zur Verwendung
                Ihrer personenbezogenen Daten und zu Widerspruchsmöglichkeiten
                erhalten Sie in der{" "}
                <a
                  href="/datenschutzerklaerung"
                  className="privacyPolicy orange-text text-darken-4"
                >
                  Datenschutzerklärung
                </a>
                .
              </p>
              <a
                onClick={this.acceptCookies}
                className="modal-close waves-effect waves-green btn-flat green white-text right"
              >
                OK
              </a>
            </div>
          </div>

          <Navbar />
          <BrowserRouter>
            <Switch>
              <Route exact path="/" component={Startsite} />
              <Route exact path="/insights" component={Insights} />
              <Route exact path="/products" component={Products} />
              <Route path="/products/:path" component={ProductItem} />
              <Route exact path="/blog" component={Blog} />
              <Route path="/blog/:path" component={BlogItem} />
              <Route exact path="/beratung" component={Consultation} />
              <Route exact path="/schulungen" component={Schooling} />
              <Route exact path="/kontakt" component={Contact} />
              <Route exact path="/impressum" component={Impressum} />
              <Route exact path="/fokusbereiche" component={Overview} />
              <Route
                exact
                path="/fokusbereiche/sharepoint-online"
                component={SharePoint}
              />
              <Route
                exact
                path="/fokusbereiche/power-platform"
                component={PowerPlatform}
              />
              <Route
                exact
                path="/fokusbereiche/webseiten"
                component={Websites}
              />
              <Route
                exact
                path="/fokusbereiche/microsoft-teams"
                component={Teams}
              />
              <Route
                exact
                path="/fokusbereiche/microsoft-azure"
                component={Azure}
              />
              <Route
                exact
                path="/fokusbereiche/softwareentwicklung"
                component={SoftwareDevelopment}
              />
              <Route
                exact
                path="/datenschutzerklaerung"
                component={DataPrivacy}
              />
              <Route exact path="*" component={_404} />
            </Switch>
          </BrowserRouter>
          <Footer />
        </div>
      </Suspense>
    );
  }
}

export default JetMinds;


// WEBPACK FOOTER //
// ./src/JetMinds.js